import React, { Fragment } from 'react';
import styled from 'styled-components';
import has from 'lodash.has';
import get from 'lodash.get';
import { onlyText } from 'react-children-utilities';
import { usePreview } from '../provider';
import Link from './link';

const useFields = (fields, rewriteFieldFn = null) => {
  const preview = usePreview();
  // read all possible fields
  const values = fields.map((field) => {
    // use lodash has and get, so we can do things like "externalLeases.0.price"
    if (!has(preview, field)) {
      console.warn(`No ${field} in PreviewComponent for ${preview.id}`);
      return null;
    }
    const value = get(preview, field);

    // allow the caller to give a specific function to handle the value
    if (rewriteFieldFn) {
      return rewriteFieldFn(value);
    }
    return value;
  }).filter(Boolean);
  // join them to a single string
  return values.join(' ');
};

const PreviewComponent = ({
  className,
  Element = 'span',
  withLink,
  field,
  fields = null,
  rewriteFieldFn = null,
  prepend = null,
  append = null,
  ...props
}) => {
  // convert a single field to an array, we will always receive a single string
  const value = useFields(fields || [field], rewriteFieldFn);
  if (!value) {
    return null;
  }

  const Wrapper = withLink ? Link : Fragment;
  return (
    <Wrapper>
      <Element
        title={`${onlyText(prepend)} ${value} ${onlyText(append)}`}
        {...props}
        className={className}
      >
        {prepend ? <span className="preview-prepend">{prepend}</span> : ''}
        <span className="preview-value">{value}</span>
        {append ? <span className="preview-append">{append}</span> : ''}
      </Element>
    </Wrapper>
  );
};

export default styled(PreviewComponent)``;
